'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zfc on 2017/3/30.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewMediumWeiBo = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(NewMediumWeiBo, _Component);

  function NewMediumWeiBo() {
    (0, _classCallCheck3.default)(this, NewMediumWeiBo);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(NewMediumWeiBo).call(this));
  }

  (0, _createClass3.default)(NewMediumWeiBo, [{
    key: 'render',
    value: function render() {
      var datas = [{
        'authorImg': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg4.jpg',
        'author': '林子CHERRY',
        'authorWork': '模特，时尚美妆达人',
        'productImg': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg5.jpg',
        'productHeader': '虞美人  我的梳子',
        'productIntro': '鸡和孔雀等工艺品。近日，记者在一次工艺品展览中发现，有两件用丝网做成的孔雀工艺品吸引了许多人。做工精细，颜色搭配合理，远远望去就像孔雀标本。当走进79岁刘倪霞老人家...',
        'date': '2017/03/14',
        'fansNum': '8623399'
      }, {
        'authorImg': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg7.jpg',
        'author': '工艺的面条',
        'authorWork': '模特，时尚美妆达人',
        'productImg': 'http://tupian.goeasy.cn:9999/yipinwang/newmedium/new_mei_bg8.jpg',
        'productHeader': '做精品工艺，传中华精神',
        'productIntro': '要买好梳子还是买牦牛角的吧，一来，牦牛是生活在世界第三极：极高地--青藏高原海拔3500米以上的地区，那里是当今世界少有的还未被污染的地区之一了~再次，牦牛的生长年。',
        'date': '2017/03/14',
        'fansNum': '8623399'
      }];
      return _react2.default.createElement(_components.NewMediumWeiBoComponent, { data: datas });
    }
  }]);
  return NewMediumWeiBo;
}(_react.Component), _class.propTypes = {
  filterData: _react.PropTypes.object
}, _temp);
exports.default = NewMediumWeiBo;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/NewMediumWeiBo/NewMediumWeiBo.js
 ** module id = 1505
 ** module chunks = 0
 **/